// Message of what ended a subscription: an Error, an AppSync `{ errors: [{ message }] }` payload, or a string.
export const getSubscriptionErrorMessage = (error: unknown): string | undefined => {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  const message = (error as { errors?: { message?: unknown }[] } | null | undefined)?.errors?.[0]?.message;

  return typeof message === 'string' ? message : undefined;
};
